<script setup lang="ts">
    import { caseCompletedMessage, useCaseSyncStore } from '@/stores/useCaseSyncStore';
    import ErrorToastie from '@/views/case-settings/case-toasties/ErrorToastie.vue';
    import CompleteToastie from '@/views/case-settings/case-toasties/CompleteToastie.vue';
    import ProcessingToastie from '@/views/case-settings/case-toasties/ProcessingToastie.vue';
    import { computed } from 'vue';

    const caseSync = useCaseSyncStore();

    const errorNotifications = computed(() => {
        const notifications = caseSync.notificationsByStudy(caseSync.study)
            .filter((notification) => {
                return notification.type === 'Error';
            });
        return [...notifications].sort((a, b) => {
            const dateA = new Date(a.timestamp);
            const dateB = new Date(b.timestamp);
            return dateB.getTime() - dateA.getTime();
        });
    });

    const completedNotifications = computed(() => {
        const notifications = caseSync.notificationsByStudy(caseSync.study)
            .filter((notification) => {
                return notification.message === caseCompletedMessage;
            });
        return [...notifications].sort((a, b) => {
            const dateA = new Date(a.timestamp);
            const dateB = new Date(b.timestamp);
            return dateB.getTime() - dateA.getTime();
        });
    });

</script>

<template>
    <div class="toasties float-right position-fixed top-1 right-0 mr-5 mt-0">
        <div v-if="caseSync.isCaseError">
            <ErrorToastie
v-for="(item, index) in errorNotifications" :key="index" :notification="item"
                          data-testid="error-toastie" />
        </div>
        <div v-if="caseSync.isCaseProcessing">
            <ProcessingToastie :case-status="caseSync.statusState" />
        </div>
        <div v-if="caseSync.isCaseComplete || caseSync.isCaseWarning">
            <CompleteToastie
:notification="completedNotifications[0] ?? null"
                             :warning="caseSync.isCaseWarning"
                             data-testid="complete-toastie" />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .toasties {
        z-index: 1000;
    }
</style>
